import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  HomeIcon,
  UsersIcon,
  FolderIcon,
  ClipboardDocumentListIcon,
  Bars3Icon
} from '@heroicons/react/24/outline';
import { useUIStore } from '../../stores';

const navigation = [
  { name: 'nav.dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'nav.clients', href: '/clients', icon: UsersIcon },
  { name: 'nav.projects', href: '/projects', icon: FolderIcon },
  { name: 'nav.tasks', href: '/tasks', icon: ClipboardDocumentListIcon }
];

export default function BottomNav() {
  const { t } = useTranslation();
  const { toggleMobileMenu } = useUIStore();
  
  return (
    <nav className="bottom-nav">
      <div className="flex items-center justify-around py-2">
        {navigation.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${
                isActive ? 'text-primary' : 'text-gray-500'
              }`
            }
          >
            <item.icon className="w-6 h-6" />
            <span className="text-xs">{t(item.name)}</span>
          </NavLink>
        ))}
        <button
          onClick={toggleMobileMenu}
          className="flex flex-col items-center gap-1 px-3 py-1 text-gray-500"
        >
          <Bars3Icon className="w-6 h-6" />
          <span className="text-xs">{t('common.more') || 'More'}</span>
        </button>
      </div>
    </nav>
  );
}
